export default {
  vermelho: ' #c23616',
  verde: '#44BD32',
  amarelo: '#e1a32a',
  amareloCard: '#fffbf2',
  cinza: '#979797',
  branco: '#ffffff',
}
